import * as yup from 'yup';

// Order code: cualquier longitud, requerido
const orderCodeSchema = yup
  .string()
  .typeError('schemas.orderCode.string')
  .required('schemas.orderCode.required');

export default orderCodeSchema;
